import { h } from 'preact'

import InputGroup from '../../control-components/ui-components/InputGroup'

interface Props {
  credentials: { id: string, secret: string }
}

const Credentials = ({ credentials }: Props) => {
  return (
    <section>
      <InputGroup title='Client ID' value={credentials.id} disabled />
      <InputGroup title='Client secret' value={credentials.secret} disabled />
      <div className='alert alert-warning'>
        <p>Make sure you copy and store your Client ID and Client Secret - we won’t show them again after you leave this page.</p>
        <p>Take care to keep your client credentials secure.</p>
        <p>Publicly exposing your credentials can result in your account being compromised, which could lead to unexpected/malicious behaviour on your community.</p>
      </div>
    </section>
  )
}

export default Credentials
